import { FC, Fragment, ReactNode } from 'react';
import { Chip } from '@material-ui/core';

// Parses inline @[label](type:id) tokens and renders them as chips, leaving the
// rest of the message as plain text. (React nodes only — never dangerouslySetHTML.)
const MENTION_RE = /@\[([^\]]+)\]\(([a-z]+):([^)]*)\)/g;

interface MentionedTextProps {
  text: string;
}

export const MentionedText: FC<MentionedTextProps> = ({ text }) => {
  if (!text) {
    return null;
  }
  const nodes: ReactNode[] = [];
  let last = 0;
  let key = 0;
  let m: RegExpExecArray | null;
  MENTION_RE.lastIndex = 0;
  while ((m = MENTION_RE.exec(text)) !== null) {
    if (m.index > last) {
      nodes.push(<Fragment key={`t${key}`}>{text.slice(last, m.index)}</Fragment>);
    }
    nodes.push(
      <Chip
        key={`m${key}`}
        size="small"
        color="primary"
        variant="outlined"
        label={`@${m[1]}`}
        sx={{ mx: 0.25, height: 20 }}
      />
    );
    last = m.index + m[0].length;
    key += 1;
  }
  if (last < text.length) {
    nodes.push(<Fragment key={`t${key}`}>{text.slice(last)}</Fragment>);
  }
  return <>{nodes}</>;
};
